import { toast } from "react-toastify";
import { toastOptions } from "../../../../config/toast";
import { axios } from "../../../../utils/axios";

export const getIncidencias = async (camara_id, setIncidencias) => {
  setIncidencias((prevState) => ({
    ...prevState,
    is_loading: true,
  }));

  const result = await axios().get(`/incidencias/${camara_id}`);

  const { data, error } = result.data;

  if (data) {
    setIncidencias((prevState) => ({
      ...prevState,
      is_loading: false,
      data: result.data.data,
    }));
  }

  if (error) {
    toast.error(error, toastOptions);
    setIncidencias((prevState) => ({
      ...prevState,
      is_loading: false,
    }));
  }
};

export const handleAgregarIncidencia = async (submittedData, setIncidencias, setError) => {
  // console.log(submittedData);
  if (submittedData.fecha_incidencia === "") {
    delete submittedData.fecha_incidencia;
  } else {
    const formattedDateTime = submittedData.fecha_incidencia.replace("T", " ");
    submittedData.fecha_incidencia = formattedDateTime;
  }
  // console.log(submittedData);
  // return;
  const result = await axios().post("/incidencias", submittedData);
  const { status } = result;
  const { error, data } = result.data;

  if (data) {
    setIncidencias((prevState) => ({
      ...prevState,
      agregar_incidencia: false,
      data: [data, ...prevState.data],
    }));
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.entries(error).forEach((err, i) => {
        setError(err[0], { type: err[0], message: err[1][0] }, { shouldFocus: false });
      });
    }
  }
};
